import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import CircularProgress from '@material-ui/core/CircularProgress';
import { TemplateField } from '../../../../components/templateEditor/templateField';
import { DefaultFieldsContainer } from './DefaultFieldsContainer';
import api from '../../../../infrastructure/api/api';

const DefaultFields = props => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const defaultFieldsContainer = DefaultFieldsContainer.useContainer();

  useEffect(() => {
    defaultFieldsContainer.setFieldsAndTemplates(props.fieldsAndTemplates);
  }, [props.fieldsAndTemplates, defaultFieldsContainer]);

  const [selectOptions, setSelectOptions] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    api
      .get('templateRuleFieldConfiguration', enqueueSnackbar, t)
      .then(selectOptionsResult => {
        if (selectOptionsResult !== null) {
          setSelectOptions(selectOptionsResult);
        }
        setIsLoading(false);
      });
  }, [enqueueSnackbar, t]);

  if (isLoading) {
    return <CircularProgress style={{ width: 60, height: 60 }} />;
  }

  return (
    <>
      <Grid item xs={12} container>
        <TemplateField
          addButtonAlwaysVisible
          selectOptions={selectOptions}
          rule={props.fieldsAndTemplates.defaultFields}
          fieldName="series"
          usedContainer={DefaultFieldsContainer}
        />
      </Grid>
      <Grid item xs={12} container>
        <TemplateField
          addButtonAlwaysVisible
          selectOptions={selectOptions}
          rule={props.fieldsAndTemplates.defaultFields}
          fieldName="company"
          usedContainer={DefaultFieldsContainer}
        />
      </Grid>
      <Grid item xs={12} container>
        <TemplateField
          addButtonAlwaysVisible
          selectOptions={selectOptions}
          rule={props.fieldsAndTemplates.defaultFields}
          fieldName="voucherText"
          usedContainer={DefaultFieldsContainer}
        />
      </Grid>
      <Grid item xs={12} container>
        <TemplateField
          addButtonAlwaysVisible
          selectOptions={selectOptions}
          rule={props.fieldsAndTemplates.defaultFields}
          fieldName="transactionText"
          usedContainer={DefaultFieldsContainer}
        />
      </Grid>
    </>
  );
};

export default DefaultFields;

DefaultFields.propTypes = {
  fieldsAndTemplates: PropTypes.object,
};
